"use client"

import { Button } from "@heroui/react"
import ImageComponent from "../ImageComponent"
import { useDispatch } from "react-redux"
import { openModal } from "@/redux/slices/allModalSlice"
import { BOOK_APPOINTMENT_MODAL_PLACEMENT } from "@/util/enum"
import { useBookAppointmentModalSize } from "@/components/ui/hooks/useBookAppointmentModalSize"

export interface BackgroundImageCTAProps{
    image_url:string,
    title:string,
    description:string,
    btn_text:string,
    btn_link?:string,
}

const BackgroundImageCTA = ({image_url,title,description,btn_text}:BackgroundImageCTAProps) => {

    const dispatch = useDispatch()
    const bookAppointmentModalSize = useBookAppointmentModalSize()

    return (
        <>
            <div className="min-h-[180px] sm:min-h-0 sm:h-[142px]! 2xl:h-40! relative overflow-hidden">

                <div className="absolute inset-0">
                    <ImageComponent url={image_url || '/images/home_data/bookAppointment.jpg'} img_title='Main Banner' object_cover={true} />
                </div>

                {/* Gradient overlay */}
                <div className="absolute inset-0 bg-linear-to-b from-transparent via-black/10 to-black/20 pointer-events-none h-full" />

                <div className='block absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 z-10 space-y-6 w-full space_from_side'>
                    <div className="flex flex-col md:flex-row justify-between items-center gap-y-5">
                        <div className="space-y-2">
                            <h3 className="text-lightBrown text-base md:text-2xl/[33.6px] 2xl:text-3xl/[33.6px] font-semibold text-center md:text-start">{title}</h3>
                            <p className="text-sm md:text-base/[25.6px] text-white pe-3 md:pd-0 text-center md:text-start">{description}</p>
                        </div>
                        <Button
                            className="btn_responsive_cta silverblue_btn mx-auto"
                            onPress={() =>
                                dispatch(
                                    openModal({
                                        componentName: "BookAppointmentModal",
                                        modalSize: bookAppointmentModalSize,
                                        placement: BOOK_APPOINTMENT_MODAL_PLACEMENT,
                                    })
                                )
                            }
                        >
                            {btn_text}
                        </Button>
                    </div>
                </div>
            </div>
        </>
    )
}

export default BackgroundImageCTA
